import { FC, useEffect, useState } from 'react';
import { Button, Form, Modal, Radio } from 'antd';
import close from '../../../assets/RoundedClose.svg';
import { DatePickerInput } from '../../Fields/DatePickerInput';
import { useUpdateTaskMutation } from '../../../api/tenders';
import { tenderDataProps } from '../../../pages/TenderViewPage/types';
import { Loader } from '../../Loader/Loader';
import i from '../../../assets/i.svg';
import moment from 'moment';

interface ModalProps {
    openModal: boolean;
    setOpenModal: React.Dispatch<React.SetStateAction<boolean>>;
    tenderData: tenderDataProps;
    setTrigger: React.Dispatch<React.SetStateAction<boolean>>;
}

export const SiteVisitModal: FC<ModalProps> = ({ openModal, setOpenModal, tenderData, setTrigger }) => {
    const [form] = Form.useForm();

    const [updateTask, { isSuccess, isLoading }] = useUpdateTaskMutation();

    const [data, setData] = useState<{ id: number; time: string; date: string }[]>([
        { id: 1, time: '', date: '' },
        { id: 2, time: '', date: '' }
    ]);

    console.log('data', data);

    const [errors, setErrors] = useState<Record<number, boolean>>({
        1: false,
        2: false
    });

    const validateSlots = (slots: { id: number; time?: string; date?: string }[]) => {
        const newErrors: Record<number, boolean> = {};

        console.log('slots', slots);

        slots?.forEach((slot) => {
            newErrors[slot.id] = !slot.time || !slot.date;
        });

        setErrors(newErrors);

        return Object.values(newErrors).every((error) => !error);
    };

    useEffect(() => {
        if (tenderData) {
            const taskData = tenderData?.phase_tasks?.find((elem) => elem.action === 'define_site_visit_date');

            if (taskData?.slots) {
                const prefilledData = taskData?.slots?.map((slot: any, index: number) => ({
                    id: index + 1,
                    time: slot.time,
                    date: slot.date
                }));
                setData(prefilledData);

                form.setFieldsValue({
                    radiogroup_1: taskData?.slots?.[0]?.time,
                    radiogroup_2: taskData?.slots?.[1]?.time
                });
            }
        }
    }, [tenderData]);

    useEffect(() => {
        if (isSuccess) {
            setOpenModal(false);
            setTrigger((prev) => !prev);
        }
    }, [isSuccess]);

    const handleFormSubmit = () => {
        const isValid = validateSlots(data);

        if (isValid) {
            const dataToUpdate = {
                ids: {
                    tender_id: tenderData?.id,
                    task_id: tenderData?.phase_tasks?.find((elem) => elem.action === 'define_site_visit_date')?.id
                },

                method: 'PUT',
                data: {
                    slots: [
                        {
                            time: data[0].time,
                            date: moment(data[0].date).format('YYYY-MM-DD')
                        },
                        {
                            time: data[1].time,
                            date: moment(data[1].date).format('YYYY-MM-DD')
                        }
                    ]
                }
            };

            if (isLoading) return;
            updateTask(dataToUpdate);
        }
    };

    const updateSlot = (id: number, payload: Partial<{ time: string; date: string }>) => {
        setData((prev) => prev?.map((slot) => (slot.id === id ? { ...slot, ...payload } : slot)));

        setErrors((prevErrors) => {
            const { [id]: _, ...rest } = prevErrors;
            return rest;
        });
    };

    const isDayDisabled = (date: Date) => {
        const today = new Date();
        today.setHours(0, 0, 0, 0);

        const start = new Date(today);
        start.setDate(today.getDate() + 1);

        const end = new Date(today);
        end.setDate(today.getDate() + 3);

        return date < start || date > end;
    };

    return (
        <>
            <Modal
                className="modal-modal"
                destroyOnClose
                centered
                open={openModal}
                onOk={() => {}}
                onCancel={() => {
                    setOpenModal(false);
                }}
                closeIcon={<img src={close} />}
                footer={<></>}
            >
                <div className="modal">
                    <div className="modal__header meeting" style={{ height: '88px' }}>
                        <div className="modal__title">Site visit date</div>
                    </div>

                    <div className="modal__main main" style={{ padding: '24px 56px 43px 56px' }}>
                        <div className="note">
                            <img src={i} />
                            <div>
                                Select a date and time at least three business days from now. Our team will visit your
                                site to understand your requirements and gather the necessary information. We’ll confirm
                                the visit time with you afterwards.
                            </div>
                        </div>
                        <p className="main__subtitle">Provide available slots for supplier pitches</p>
                        <Form form={form} onFinish={handleFormSubmit}>
                            <div className={`slot slot-visit-site ${errors[1] ? 'error' : ''}`}>
                                <div className="slot__title">Slot 1</div>

                                <Form.Item name="radiogroup_1">
                                    <Radio.Group className="main__radiogroup site-visit">
                                        <Radio value="morning" onChange={() => updateSlot(1, { time: 'morning' })}>
                                            Morning
                                        </Radio>
                                        <Radio value="afternoon" onChange={() => updateSlot(1, { time: 'afternoon' })}>
                                            Afternoon
                                        </Radio>
                                        <Radio
                                            value="no_preference"
                                            onChange={() => updateSlot(1, { time: 'no_preference' })}
                                        >
                                            No preference
                                        </Radio>
                                    </Radio.Group>
                                </Form.Item>

                                <Form.Item>
                                    <DatePickerInput
                                        value={data?.find((s) => s.id === 1)?.date}
                                        onChange={(date: string) => updateSlot(1, { date })}
                                        required
                                        floatLabel="Meeting Date"
                                        placeholder={''}
                                        disabled={false}
                                        filterDisabled={isDayDisabled}
                                    />
                                </Form.Item>
                            </div>
                            {errors[1] && (
                                <div className="error-text" style={{ margin: '-15px 0 10px 0' }}>
                                    These are required fields
                                </div>
                            )}
                            <div className={`slot slot-visit-site ${errors[2] ? 'error' : ''}`}>
                                <div className="slot__title">Slot 2</div>

                                <Form.Item name="radiogroup_2">
                                    <Radio.Group className="main__radiogroup site-visit">
                                        <Radio value="morning" onChange={() => updateSlot(2, { time: 'morning' })}>
                                            Morning
                                        </Radio>
                                        <Radio value="afternoon" onChange={() => updateSlot(2, { time: 'afternoon' })}>
                                            Afternoon
                                        </Radio>
                                        <Radio
                                            value="no_preference"
                                            onChange={() => updateSlot(2, { time: 'no_preference' })}
                                        >
                                            No preference
                                        </Radio>
                                    </Radio.Group>
                                </Form.Item>

                                <Form.Item>
                                    <DatePickerInput
                                        value={data?.find((s) => s.id === 2)?.date}
                                        onChange={(date: string) => updateSlot(2, { date })}
                                        required
                                        floatLabel="Meeting Date"
                                        placeholder={''}
                                        disabled={false}
                                        filterDisabled={isDayDisabled}
                                    />
                                </Form.Item>
                            </div>

                            {errors[2] && (
                                <div className="error-text" style={{ margin: '-15px 0 10px 0' }}>
                                    These are required fields
                                </div>
                            )}

                            <div style={{ display: 'flex', justifyItems: 'space-between', gap: '16px', width: '100%' }}>
                                <Button block onClick={() => setOpenModal(false)}>
                                    Cancel
                                </Button>
                                <Button block type="primary" onClick={handleFormSubmit}>
                                    {isLoading ? <Loader /> : 'Save'}
                                </Button>
                            </div>
                        </Form>
                    </div>
                </div>
            </Modal>
        </>
    );
};
